import Text from '@components/Text';
import colors from '@constants/colors';
import styled from '@emotion/styled';
import { useTranslation } from 'react-i18next';

function CartNote() {
    const { t } = useTranslation('cart');
    return (
        <Wrapper>
            <Text color={colors.textSecondary}>
                {t('note.message')}
            </Text>
        </Wrapper>
    );
}

const Wrapper = styled.aside`
    background-color: var(--color-background-base);
    border-radius: var(--radius-sm);
    margin: var(--spacing-4);
    padding: var(--spacing-3);
    width: calc(100% - var(--spacing-8));
`;

export default CartNote;
